// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","SmartTextareaInput":"bgs_a bie_ve bie_vr bie_xh bie_vj"};